<template>
  <div>
    <template v-if="!detailItem && !showDetailSection">
    <div class="gov-section">
      <div class="icon-row">
        <div
          v-for="(item, index) in iconList"
          :key="index"
          class="icon-item"
          :class="{ active: selectedIcon === index }"
          @click="onIconClick(index)"
        >
          <img :src="item.img" alt="" class="icon-img">
          <div class="icon-label">{{ item.title }}</div>
        </div>
      </div>
    </div>
    <div v-if="selectedIcon >= 0" class="breadcrumb">
      <img :src="pointImg" alt="" class="breadcrumb-icon">
      <span>当前位置：<span class="breadcrumb-link" @click="$emit('go-home')">首页</span> / <span class="breadcrumb-link" @click.stop="onBackToIcons">政务资讯</span> / {{ iconList[selectedIcon].title }}</span>
    </div>
    <div v-if="selectedIcon === -1" class="content-wrap">
      <div class="section-title-row">
        <div class="title-area" @click="openSection('新闻资讯')" style="cursor:pointer">
          <span class="title-line"></span>
          <span class="section-title">新闻资讯</span>
          <span class="title-line"></span>
        </div>
        <div class="news-cards">
          <div v-for="(item, index) in allNewsCards.slice(0, 3)" :key="index" class="news-card" @click="openDetail('新闻资讯', item)">
            <div class="card-title">{{ item.title }}</div>
            <div class="card-desc">{{ item.desc }}</div>
            <div class="card-date">{{ item.date }}</div>
          </div>
        </div>
      </div>
      <div class="section-title-row">
        <div class="title-area" @click="openSection('政务信息')" style="cursor:pointer">
          <span class="title-line"></span>
          <span class="section-title">政务信息</span>
          <span class="title-line"></span>
        </div>
        <div class="gov-grid">
           <div v-for="(item, index) in allGovGrid.slice(0, 6)" :key="index" class="gov-card" @click="openDetail('政务信息', {id: item.id, title: item.title, desc: item.desc, date: item.month + item.day})">
            <div class="gov-card-top">
              <div class="gov-card-title">{{ item.title }}</div>
              <div class="gov-card-date">
                <div class="date-day">{{ item.day }}</div>
                <div class="date-month">{{ item.month }}</div>
              </div>
            </div>
            <div class="gov-card-divider"></div>
            <div class="gov-card-bottom">查看更多>></div>
          </div>
        </div>
      </div>
      <div class="info-section">
        <div class="info-col">
          <div class="section">
            <div class="section-header" @click="openSection('政务公开')" style="cursor:pointer">
              <span class="section-title">政务公开</span>
            </div>
            <div class="news-list">
              <div v-for="(item, index) in allGovList.slice(0, 6)" :key="index" class="news-item" @click="openDetail('政务公开', item)">
                <span class="news-dot"></span>
                <span class="news-title">{{ item.title }}</span>
                <span class="news-date">{{ item.date }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="info-col">
          <div class="section">
            <div class="section-header" @click="openSection('政策法规')" style="cursor:pointer">
              <span class="section-title">政策法规</span>
            </div>
            <div class="news-list">
              <div v-for="(item, index) in allPolicyList.slice(0, 6)" :key="index" class="news-item" @click="openDetail('政策法规', item)">
                <span class="news-dot"></span>
                <span class="news-title">{{ item.title }}</span>
                <span class="news-date">{{ item.date }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="selectedIcon === 0" class="icon-content leader-content">
      <div class="leader-page">
        <div class="leader-left">
          <div class="accordion-group">
            <div class="left-nav-item has-dropdown" :class="{ expanded: expandedCategory === 'scenic' }" @click="toggleCategory('scenic')">
              <span>景区领导</span>
              <span class="arrow" :class="{ open: expandedCategory === 'scenic' }">▶</span>
            </div>
            <div v-if="expandedCategory === 'scenic'" class="side-menu">
              <div
                v-for="(item, index) in leaders"
                :key="index"
                class="leader-name-item"
                :class="{ active: selectedLeaderCategory === 'scenic' && selectedLeaderIndex === index }"
                @click.stop="selectLeader('scenic', index)"
              >{{ item.name }}</div>
            </div>
          </div>
          <div class="accordion-group">
            <div class="left-nav-item has-dropdown" :class="{ expanded: expandedCategory === 'group' }" @click="toggleCategory('group')">
              <span>集团领导</span>
              <span class="arrow" :class="{ open: expandedCategory === 'group' }">▶</span>
            </div>
            <div v-if="expandedCategory === 'group'" class="side-menu">
              <div
                v-for="(item, index) in groupLeaders"
                :key="index"
                class="leader-name-item"
                :class="{ active: selectedLeaderCategory === 'group' && selectedLeaderIndex === index }"
                @click.stop="selectLeader('group', index)"
              >{{ item.name }}</div>
            </div>
          </div>
        </div>
        <div v-if="currentLeader" class="leader-right">
          <div class="leader-section">
            <div class="leader-section-title">我的简介</div>
            <div class="leader-intro">
              <img :src="currentLeader.img" alt="" class="leader-photo">
              <div class="leader-desc">{{ currentLeader.description }}</div>
            </div>
          </div>
          <div class="leader-section" v-if="currentLeader.chargeOf || currentLeader.contactPoint">
            <div class="leader-section-title">我的分工</div>
            <div class="leader-division">
              <p v-if="currentLeader.chargeOf"><strong>分管：</strong>{{ currentLeader.chargeOf }}</p>
              <p v-if="currentLeader.contactPoint"><strong>联系点：</strong>{{ currentLeader.contactPoint }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="selectedIcon === 1" class="icon-content">
      <div class="leader-title">机构设置</div>
      <div class="org-tabs">
        <span class="org-tab" :class="{ active: selectedOrg === 'scenic' }" @click="switchOrg('scenic')">花果山风景区管理处</span>
        <span class="org-tab" :class="{ active: selectedOrg === 'group' }" @click="switchOrg('group')">花果山文化旅游集团</span>
      </div>
      <div class="rich-content" v-html="orgContent"></div>
    </div>
    <div v-if="selectedIcon === 2" class="icon-content">
      <div class="leader-title">领导信箱</div>
      <div class="mail-form">
        <div class="form-item">
          <label class="form-label"><span class="required">*</span>姓名</label>
          <input v-model="mailForm.name" type="text" class="form-input" placeholder="请输入姓名">
        </div>
        <div class="form-item">
          <label class="form-label"><span class="required">*</span>电话</label>
          <input v-model="mailForm.phone" type="text" class="form-input" placeholder="请输入联系电话">
        </div>
        <div class="form-item">
          <label class="form-label"><span class="required">*</span>主题</label>
          <input v-model="mailForm.subject" type="text" class="form-input" placeholder="请输入主题">
        </div>
        <div class="form-item">
          <label class="form-label"><span class="required">*</span>内容</label>
          <textarea v-model="mailForm.content" class="form-textarea" placeholder="请输入内容"></textarea>
        </div>
        <div class="form-submit" @click="submitMail">提交</div>
      </div>
    </div>
    <div v-if="selectedIcon === 3" class="icon-content">
      <div class="leader-title">纪检举报</div>
      <div class="rich-content" v-html="disciplineContent"></div>
    </div>
    <div v-if="selectedIcon === 4" class="icon-content">
      <div class="leader-title">意见建议</div>
      <div class="mail-form">
        <div class="form-item">
          <label class="form-label"><span class="required">*</span>姓名</label>
          <input v-model="mailForm.name" type="text" class="form-input" placeholder="请输入姓名">
        </div>
        <div class="form-item">
          <label class="form-label"><span class="required">*</span>电话</label>
          <input v-model="mailForm.phone" type="text" class="form-input" placeholder="请输入联系电话">
        </div>
        <div class="form-item">
          <label class="form-label"><span class="required">*</span>主题</label>
          <input v-model="mailForm.subject" type="text" class="form-input" placeholder="请输入主题">
        </div>
        <div class="form-item">
          <label class="form-label"><span class="required">*</span>内容</label>
          <textarea v-model="mailForm.content" class="form-textarea" placeholder="请输入内容"></textarea>
        </div>
        <div class="form-submit" @click="submitMail">提交</div>
      </div>
    </div>
    </template>
    <GovDetail v-if="detailItem || showDetailSection" :article="detailItem" :section="detailSection || showDetailSection" :list-a="allNewsCards" :list-b="allGovGrid" :list-c="allGovList" :list-d="allPolicyList" :total-a="govTotals.gov_news" :total-b="govTotals.gov_info" :total-c="govTotals.gov_public" :total-d="govTotals.policies" @go-home="$emit('go-home')" @close="onCloseDetail" />
  </div>
</template>

<script>
import img1 from '../assets/imgs/组 31@2x (2).png'
import img2 from '../assets/imgs/组 31 拷贝@2x.png'
import img3 from '../assets/imgs/组 31 拷贝 2@2x.png'
import img4 from '../assets/imgs/组 31 拷贝 3@2x.png'
import img5 from '../assets/imgs/组 31 拷贝 4@2x.png'
import { getArticles, getArticleDetail, getLeaders, submitMessage } from '../api/index'
import thumbImg from '../assets/imgs/ceshi.png'
import pointImg from '../assets/imgs/point.png'
import GovDetail from './GovDetail.vue'

export default {
  name: 'GovSection',
  props: {
    defaultSection: { type: String, default: '' },
    defaultArticle: { type: Object, default: null },
  },
  emits: ['go-home'],
  components: {
    GovDetail,
  },
  data() {
    return {
      selectedIcon: -1,
      selectedLeaderIndex: null,
      selectedLeaderCategory: 'scenic',
      expandedCategory: 'scenic',
      groupLeaders: [],
      detailItem: null,
      detailSection: '',
      showDetailSection: '',
      currentIndex: -1,
      iconList: [
        { img: img1, title: '景区领导' },
        { img: img2, title: '机构设置' },
        { img: img3, title: '领导信箱' },
        { img: img4, title: '纪检举报' },
        { img: img5, title: '意见建议' },
      ],
      thumbImg,
      pointImg,
      leaders: [],
      orgContent: '<p>加载中...</p>',
      selectedOrg: 'scenic',
      disciplineContent: '<p>加载中...</p>',
      mailForm: {
        name: '',
        email: '',
        phone: '',
        subject: '',
        content: '',
      },
      allNewsCards: [],
      allGovGrid: [],
      allGovList: [],
      allPolicyList: [],
      govTotals: { gov_news: 0, gov_info: 0, gov_public: 0, policies: 0 },
    }
  },
  computed: {
    currentLeader() {
      if (this.selectedLeaderIndex === null) return null
      const arr = this.selectedLeaderCategory === 'scenic' ? this.leaders : this.groupLeaders
      return arr[this.selectedLeaderIndex] || null
    },
  },
  watch: {
    selectedIcon(val) {
      if (val !== -1) this.$nextTick(() => { window.scrollTo(0, 0) })
      if (val === 0) {
        this.fetchLeaders()
        this.fetchGroupLeaders()
      }
      if (val === 1) this.fetchOrgData()
      if (val === 3) this.fetchDisciplineData()
    },
    detailItem(val) { if (val) this.$nextTick(() => { window.scrollTo(0, 0) }) },
    showDetailSection(val) { if (val) this.$nextTick(() => { window.scrollTo(0, 0) }) },
    '$route.query.govArticle': {
      handler(val) {
        if (!val && !this.$route.query.govTab) {
          this.detailItem = null
          this.showDetailSection = ''
        }
      },
    },
    '$route.query.govIcon': {
      handler(val) {
        const idx = parseInt(val)
        if (!isNaN(idx) && idx !== this.selectedIcon) this.selectedIcon = idx
      },
    },
  },
  mounted() {
    const q = this.$route.query
    const govIcon = parseInt(q.govIcon)
    if (!isNaN(govIcon) && govIcon >= 0) this.selectedIcon = govIcon
    const tabMap = ['新闻资讯', '政务信息', '政务公开', '政策法规']
    const govTab = parseInt(q.govTab)
    if (!isNaN(govTab) && govTab >= 0 && govTab <= 3 && !q.govIcon) {
      this.showDetailSection = tabMap[govTab]
      this.detailSection = tabMap[govTab]
      this.selectedIcon = -1
    }
    if (this.defaultArticle) {
      this.detailItem = this.defaultArticle
      this.detailSection = this.defaultSection
      const tm = { '新闻资讯': 0, '政务信息': 1, '政务公开': 2, '政策法规': 3 }
      const tab = tm[this.defaultSection] || 0
      this.$router.replace({ query: { ...this.$route.query, menu: 3, govTab: tab, govPage: 1, govArticle: this.defaultArticle.id } }).catch(() => {})
    } else if (this.defaultSection) {
      this.openSection(this.defaultSection)
    }
    this.fetchGovData()
  },
  methods: {
    async fetchOrgData() {
      try {
        const category = this.selectedOrg === 'scenic' ? 'org_structure_scenic' : 'org_structure'
        const listRes = await getArticles({ category, lang: 'zh', pageSize: 1 })
        const items = listRes.rows || listRes.data || []
        if (!items.length) {
          this.orgContent = '<p>暂无内容</p>'
          return
        }
        const detailRes = await getArticleDetail(items[0].id)
        if (detailRes.code === 200 && detailRes.data) {
          this.orgContent = detailRes.data.content || '<p>暂无内容</p>'
        }
      } catch (e) {
        this.orgContent = '<p>暂无内容</p>'
      }
    },
    switchOrg(org) {
      this.selectedOrg = org
      this.fetchOrgData()
    },
    async fetchDisciplineData() {
      try {
        const listRes = await getArticles({ category: 'discipline_report', lang: 'zh', pageSize: 1 })
        const items = listRes.rows || listRes.data || []
        if (!items.length) {
          this.disciplineContent = '<p>暂无内容</p>'
          return
        }
        const detailRes = await getArticleDetail(items[0].id)
        if (detailRes.code === 200 && detailRes.data) {
          this.disciplineContent = detailRes.data.content || '<p>暂无内容</p>'
        }
      } catch (e) {
        this.disciplineContent = '<p>暂无内容</p>'
      }
    },
    async fetchLeaders() {
      try {
        const res = await getLeaders({ lang: 'zh', leaderType: 'scenic' })
        if (res.code !== 200) return
        this.leaders = (res.data || []).map(item => ({
          img: item.photoUrl || '',
          name: item.name,
          position: item.title,
          description: item.description || '',
          chargeOf: item.title || '',
          contactPoint: item.contact || '',
        }))
        if (this.leaders.length) {
          this.selectedLeaderIndex = 0
          this.selectedLeaderCategory = 'scenic'
        }
      } catch (e) {
        console.error('获取领导列表失败:', e)
      }
    },
    async fetchGroupLeaders() {
      try {
        const res = await getLeaders({ lang: 'zh', leaderType: 'group' })
        if (res.code !== 200) return
        this.groupLeaders = (res.data || []).map(item => ({
          img: item.photoUrl || '',
          name: item.name,
          position: item.title,
          description: item.description || '',
          chargeOf: item.title || '',
          contactPoint: item.contact || '',
        }))
      } catch (e) {
        console.error('获取集团领导列表失败:', e)
      }
    },
    async fetchGovData() {
      const map = {
        gov_news: 'allNewsCards',
        gov_info: 'allGovGrid',
        gov_public: 'allGovList',
        policies: 'allPolicyList',
      }
      for (const [category, key] of Object.entries(map)) {
        try {
          const res = await getArticles({ category, lang: 'zh', pageNum: 1, pageSize: 20 })
          if (res.code !== 200) continue
          this.govTotals[category] = res.total || 0
          const list = (res.rows || []).map(item => {
            const pt = item.publishTime || ''
            const base = {
              id: item.id,
              title: item.title,
              desc: item.summary || '',
              date: pt.substring(0, 10),
            }
            if (category === 'gov_info') {
              base.month = (pt.substring(5, 7) || '01') + '月'
              base.day = pt.substring(8, 10) || '01'
            }
            return base
          })
          this[key] = list
        } catch (e) {
          console.error('获取政务数据失败:', category, e)
        }
      }
    },
    onCloseDetail() {
      this.detailItem = null
      this.showDetailSection = ''
      const q = { ...this.$route.query }
      delete q.govArticle
      delete q.govSection
      delete q.govTab
      delete q.govPage
      this.$router.replace({ query: q }).catch(() => {})
    },
    onIconClick(index) {
      this.selectedIcon = index
      this.$router.replace({ query: { ...this.$route.query, govIcon: index } }).catch(() => {})
    },
    onBackToIcons() {
      this.selectedIcon = -1
      this.$router.replace({ query: { menu: this.$route.query.menu } }).catch(() => {})
    },
    async openDetail(section, item) {
      this.detailSection = section
      this.detailItem = { ...item }
      const tabMap = { '新闻资讯': 0, '政务信息': 1, '政务公开': 2, '政策法规': 3 }
      const tab = tabMap[section] || 0
      const q = { ...this.$route.query, menu: 3, govTab: tab, govPage: 1, govArticle: item.id }
      delete q.govSection
      this.$router.replace({ query: q }).catch(() => {})
      if (item.id) {
        try {
          const res = await getArticleDetail(item.id)
          if (res.code === 200 && res.data) {
            this.detailItem = { ...item, ...res.data }
          }
        } catch (e) {
          console.error('获取文章详情失败:', e)
        }
      }
    },
    openSection(section) {
      this.showDetailSection = section
      this.detailSection = section
      const tabMap = { '新闻资讯': 0, '政务信息': 1, '政务公开': 2, '政策法规': 3 }
      const tab = tabMap[section] || 0
      const q = { ...this.$route.query, govTab: tab, govPage: 1 }
      delete q.govArticle
      this.$router.replace({ query: q }).catch(() => {})
    },
    toggleCategory(cat) {
      this.expandedCategory = this.expandedCategory === cat ? null : cat
    },
    selectLeader(category, index) {
      this.selectedLeaderCategory = category
      this.selectedLeaderIndex = index
    },
    async submitMail() {
      if (!this.mailForm.content.trim()) {
        alert('请填写内容')
        return
      }
      const type = this.selectedIcon === 2 ? 'mailbox' : 'suggestion'
      try {
        const res = await submitMessage({
          type,
          name: this.mailForm.name,
          email: this.mailForm.email,
          phone: this.mailForm.phone,
          content: this.mailForm.subject ? '【' + this.mailForm.subject + '】' + this.mailForm.content : this.mailForm.content,
        })
        if (res.code === 200) {
          alert('提交成功！')
          this.mailForm = { name: '', email: '', phone: '', subject: '', content: '' }
        } else {
          alert(res.msg || '提交失败，请稍后再试')
        }
      } catch (e) {
        alert('提交失败，请稍后再试')
      }
    },
  },
}
</script>

<style scoped lang="less">
.gov-section{
  margin-top: 0.3rem;
  padding: 0.3rem 2.72rem;
  background: url('../assets/imgs/-h-组 34.png') no-repeat center / cover;
  .icon-row{
    display: flex;
    gap: 1rem;
    .icon-item{
      flex: 1;
      cursor: pointer;
      &.active{
        .icon-label{
          color: #369BF8;
          font-weight: bold;
        }
      }
      .icon-img{
        width: 100%;
        height: 0.98rem;
        object-fit: contain;
        display: block;
      }
      .icon-label{
        height: 0.5rem;
        line-height: 0.5rem;
        text-align: center;
        font-size: 0.21rem;
        color: #2C2B2B;
      }
    }
  }
}
.breadcrumb{
  padding-top: 0.3rem;
  padding-left: 0.1rem;
  padding-right: 0.1rem;
  font-size: 0.24rem;
  color: #666;
  display: flex;
  align-items: center;
  .breadcrumb-icon{
    width: 0.2rem;
    margin-right: 0.1rem;
  }
  .breadcrumb-link{
    cursor: pointer;
    &:hover{
      color: #369BF8;
    }
  }
}
.content-wrap{
  padding: 0 0.2rem;
  margin-top: 0.5rem;
}
.icon-content{
  padding: 0 0.2rem;
  padding-bottom: 0.8rem;
  margin-top: 0.5rem;
}
.leader-title{
  font-size: 0.4rem;
  font-weight: bold;
  color: #000;
  text-align: center;
  padding: 0.2rem 0;
}
.org-tabs{
  display: flex;
  justify-content: center;
  gap: 0.15rem;
  margin-bottom: 0.3rem;
  .org-tab{
    padding: 0.1rem 0.3rem;
    border: 1px solid #0d58ba;
    border-radius: 0.05rem;
    color: #0d58ba;
    font-size: 0.22rem;
    cursor: pointer;
    &.active{
      color: #fff;
      background: #0d58ba;
    }
  }
}
.leader-page{
  display: flex;
  .leader-left{
    width: 3.23rem;
    flex-shrink: 0;
    .left-nav-item{
      height: 0.7rem;
      line-height: 0.7rem;
      text-align: center;
      font-size: 0.24rem;
      color: #fff;
      background: #369BF8;
      cursor: pointer;
      border-bottom: 1px solid rgba(255,255,255,0.2);
      &.has-dropdown{
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.08rem;
      }
      &.expanded{
        background: #2a7ad4;
      }
      .arrow{
        font-size: 0.18rem;
        transition: transform 0.2s;
        &.open{
          transform: rotate(90deg);
        }
      }
    }
    .accordion-group{
      margin-bottom: 0.15rem;
      &:last-child{ margin-bottom: 0; }
    }
    .side-menu{
      border: 1px solid #e0e0e0;
      border-top: none;
      padding: 0.2rem 0;
      .leader-name-item{
        height: 0.7rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.23rem;
        color: #787A7B;
        cursor: pointer;
        position: relative;
        text-align: center;
        &::after{
          content: '';
          position: absolute;
          left: 0.15rem;
          right: 0.15rem;
          bottom: 0;
          height: 1px;
          background: #e0e0e0;
        }
        &:last-child::after{ display: none; }
        &.active{
          font-size: 0.25rem;
          color: #1372C9;
          gap: 0.08rem;
          background: none;
          font-weight: normal;
          &::before{
            content: '';
            width: 0;
            height: 0;
            border-top: 0.06rem solid transparent;
            border-bottom: 0.06rem solid transparent;
            border-left: 0.09rem solid #369BF8;
            flex-shrink: 0;
          }
        }
        &:hover{
          background: rgba(54,155,248,0.05);
        }
      }
    }
  }
  .leader-right{
    flex: 1;
    padding: 0 0.4rem;
    .leader-section{
      margin-bottom: 0.4rem;
      .leader-section-title{
        font-size: 0.24rem;
        font-weight: bold;
        color: #000;
        padding-bottom: 0.15rem;
        border-bottom: 2px solid #369BF8;
        margin-bottom: 0.2rem;
      }
      .leader-intro{
        display: flex;
        gap: 0.3rem;
        .leader-photo{
          width: 1.6rem;
          height: 2.33rem;
          object-fit: cover;
          flex-shrink: 0;
        }
        .leader-desc{
          font-size: 0.19rem;
          color: #333;
          line-height: 1.8;
        }
      }
      .leader-duty-content{
        font-size: 0.2rem;
        color: #333;
        line-height: 1.8;
      }
      .leader-division{
        font-size: 0.19rem;
        color: #333;
        line-height: 1.8;
        p{ margin-bottom: 0.1rem; }
      }
    }
  }
}
.leader-list{
  padding: 0.4rem 1rem;
  .leader-item{
    display: flex;
    margin-bottom: 0.5rem;
    .leader-img{
      width: 2.5rem;
      object-fit: cover;
    }
    .leader-info{
      flex: 1;
      margin-left: 0.2rem;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      .leader-name{
        font-size: 0.3rem;
        font-weight: bold;
      }
      .leader-position{
        font-size: 0.2rem;
        margin-top: 0.1rem;
      }
      .leader-duty{
        font-size: 0.2rem;
        margin-top: 0.05rem;
      }
      .leader-contact{
        font-size: 0.2rem;
        margin-top: 0.05rem;
      }
    }
  }
}
.dept-list{
  .dept-item{
    margin-bottom: 0.5rem;
    .dept-name{
      font-size: 0.3rem;
      font-weight: bold;
      color: #000;
      text-align: center;
      margin-bottom: 0.1rem;
    }
    .dept-desc{
      font-size: 0.2rem;
      color: #333;
      text-align: left;
      line-height: 1.5;
    }
  }
}
.mail-form{
  padding: 0.3rem 3.5rem;
  .form-item{
    display: flex;
    align-items: center;
    margin-bottom: 0.3rem;
    .form-label{
      width: 0.7rem;
      font-size: 0.2rem;
      color: #000;
      text-align: right;
      margin-right: 0.2rem;
      .required{
        color: red;
      }
    }
    .form-input{
      flex: 1;
      height: 0.5rem;
      border: 1px solid #ccc;
      border-radius: 4px;
      padding: 0 0.15rem;
      font-size: 0.2rem;
      outline: none;
    }
    .form-textarea{
      flex: 1;
      height: 0.8rem;
      border: 1px solid #ccc;
      border-radius: 4px;
      padding: 0.1rem 0.15rem;
      font-size: 0.2rem;
      outline: none;
      resize: vertical;
    }
  }
  .form-submit{
          width: 2rem;
    height: 0.6rem;
    line-height: 0.6rem;
    text-align: center;
    background: #369BF8;
    color: #fff;
    font-size: 0.22rem;
    border-radius: 4px;
    cursor: pointer;
    margin: 0 auto;
  }
}
.report-title{
  font-size: 0.4rem;
  font-weight: bold;
  color: #000;
  text-align: center;
  padding: 0.2rem 0;
}
.report-time{
  font-size: 0.18rem;
  color: #666;
  text-align: center;
  padding-bottom: 0.3rem;
}
.report-content{
  padding: 0 0.5rem;
  .report-item{
    font-size: 0.2rem;
    color: #333;
    line-height: 2;
    a{
      color: #369BF8;
      text-decoration: underline;
    }
  }
}
.rich-content{
  padding: 0.3rem;
  font-size: 0.2rem;
  color: #4F4E4E;
  line-height: 2.2;
  ::v-deep img{ max-width: 13rem !important; height: auto !important; }
}
.report-section{
  padding: 0.3rem 0.5rem;
  .report-section-title{
    font-size: 0.24rem;
    font-weight: bold;
    color: #000;
    margin-bottom: 0.2rem;
  }
  .report-desc{
    p{
      font-size: 0.2rem;
      color: #333;
      line-height: 1.8;
      margin-bottom: 0.1rem;
    }
    .report-warn{
      font-size: 0.3rem;
      font-weight: bold;
      margin-top: 0.2rem;
    }
  }
}
.empty-state{
  text-align: center;
  padding: 1rem 0;
  font-size: 0.24rem;
  color: #999;
}
.section-title-row{
  margin-top: 0.1rem;
  padding: 0.5rem 0rem 0.7rem 0rem;
  position: relative;
  &:first-of-type{
    padding: 0 0.7rem;
  }
.title-area{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0.4rem;
    .title-line{
      width: 0.76rem;
      height: 0.02rem;
      background: #005196;
    }
    .section-title{
      font-size: 0.41rem;
      color: #005196;
      font-family: FZShuSong-Z01S;
      margin: 0 0.3rem;
    }
  }
  .news-cards{
    display: flex;
    margin-top: 0.2rem;
      .news-card{
        flex: 1;
        padding: 0 0.2rem;
        border-right: 1px solid #e0e0e0;
        display: flex;
        flex-direction: column;
        cursor: pointer;
      &:first-child{
        padding-left: 0;
      }
      &:last-child{
        border-right: none;
        padding-right: 0;
      }
      .card-title{
        font-size: 0.21rem;
        color: #005196;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        min-height: 0.6rem;
        line-height: 0.3rem;
      }
      .card-desc{
        font-size: 0.19rem;
        color: #4B4C4D;
        margin-top: 0.15rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        flex: 1;
        line-height: 0.37rem;
      }
      .card-date{
        font-size: 0.19rem;
        color: #7E7E7F;
        margin-top: 0.3rem;
      }
    }
  }
}
.gov-grid{
  display: flex;
  flex-wrap: wrap;
  gap: 0.28rem;
  padding: 0 0.2rem;
  .gov-card{
    width: calc((100% - 0.56rem) / 3);
    border: 0.01rem solid #E5E5E5;
    cursor: pointer;
    .gov-card-top{
      display: flex;
      padding: 0.2rem 0.15rem;
      .gov-card-title{
        flex: 1;
        min-width: 0;
        font-size: 0.2rem;
        color: #141414;
        line-height: 0.32rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        margin-right: 0.1rem;
      }
      .gov-card-date{
        flex-shrink: 0;
        text-align: center;
        background: #0B78D5;
        padding: 0.08rem 0.1rem;
          .date-day{
            font-size: 0.36rem;
            color: #fff;
            line-height: 1;
          }
        .date-month{
        font-size: 0.3rem;
          color: #fff;
          line-height: 1;
          margin-top: 0;
        }
      }
    }
    .gov-card-divider{
      height: 0.01rem;
      background: #E5E5E5;
      margin: 0 0.15rem;
    }
    .gov-card-bottom{
      height: 0.5rem;
      line-height: 0.5rem;
      font-size: 0.16rem;
      color: #141414;
      cursor: pointer;
      padding-left: 0.15rem;
    }
  }
}
.info-section{
  padding: 0 0.2rem;
  display: flex;
  gap: 0.1rem;
  margin-top: 0.1rem;
  margin-bottom: 0.4rem;
  .info-col{
    flex: 1;
    min-width: 0;
    overflow: hidden;
  }
}
.section{
  .section-header{
    height: 0.6rem;
    background: rgba(0,0,0,.05);
    display: flex;
    align-items: center;
    .section-title{
      height: 0.6rem;
      width: 1.8rem;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.24rem;
      color: #fff;
      background: #369BF8;
    }
  }
  .feature-img-item{
    display: flex;
    padding: 0.1rem 0.2rem 0.1rem 0;
    cursor: pointer;
    .fi-img{
      width: 2.08rem;
      height: 1.31rem;
      object-fit: cover;
      flex-shrink: 0;
      margin-right: 0.15rem;
    }
    .fi-info{
      flex: 1;
      min-width: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .fi-title{
        font-size: 0.24rem;
        color: #2C2C2C;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .fi-desc{
        font-size: 0.16rem;
        color: #4C4B4B;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        margin: 0.08rem 0;
      }
    }
  }
  .news-list{
    .news-item{
      display: flex;
      align-items: center;
      padding: 0.05rem 0.3rem 0.05rem 0;
      cursor: pointer;
      &:hover{
        background: rgba(0,0,0,.03);
      }
      .news-dot{
        width: 0.05rem;
        height: 0.05rem;
        border-radius: 50%;
        background: #0E8064;
        flex-shrink: 0;
        margin-right: 0.05rem;
      }
      .news-title{
        flex: 1;
        min-width: 0;
        font-size: 0.19rem;
        color: #2C2C2C;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 0.2rem;
      }
      .news-date{
        font-size: 0.19rem;
        color: #989898;
        flex-shrink: 0;
      }
    }
  }
}
</style>
